<template>
  <div class="shipment_air">
    <div class="row __centerblock">
      <div class="col text-center">
        <h3 class="text-center __titleGlobal">
          Select Shipment Type
        </h3>
          <button
            class="__block"
            type="button"
            name="button"
            @click="chooseAir('cargo')"
            v-bind:class="{ active: isCargo }"
          >
            <img src = "@/assets/image/instantprice/Group 2096.svg">
            <p class="__title">Air Cargo</p>
          </button>
          <button
            class="__block"
            type="button"
            name="button"
            @click="chooseAir('courier')"
            v-bind:class="{ active: isCourier }"
          >
            <img src = "@/assets/image/instantprice/box air courier.svg">
            <p class="__title">Air Courier</p>
          </button>
          <div v-if="type === 'cargo'">
            <div class="d-flex justify-content-center __inputfield" style="margin-bottom: 70px">
                <div class="row __customdropdown">
                  <p>Qty</p>
                </div>
                <div class="row row __weight">
                  <p>Weight</p>
                </div>
                <div class="row row __size">
                  <p>Volume</p>
                </div>
            </div>
            <div
              v-for="(item, i) in form.loadsAIRCargo"
              v-bind:key="i">
              <div class="d-flex justify-content-center align-items-center __inputfield" style="margin-top: -53px; margin-bottom: 70px;">
                <div class="row __customdropdown">
                  <!-- <p>Qty</p> -->
                  <!-- <p v-else style="margin: 0 27px"></p> -->
                  <b-input-group>
                    <b-form-input
                      placeholder=""
                      v-model="item.qty"
                      @keyup="calcTotalShipment()"
                      type="number"
                    />
                    <b-dropdown right text="Palletes" variant="" slot="append"
                      :disabled="i > 0">
                      <template slot="button-content">
                        {{ item.type }}
                      </template>
                      <b-dropdown-item
                        @click="setType('Boxes')">
                        <span>Boxes</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="setType('Crates')">
                        <span>Crates</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="setType('Palletes')">
                        <span>Palletes</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group>
                  <div class="text-left input-group __input">
                    <small class="text-danger" v-if="error.loadsCargo[i].qty && showError">Required</small>
                  </div>
                </div>
                <div class="row __weight">
                  <!-- <p>Weight</p> -->
                  <b-input-group
                    size="md"
                    append="kg"
                  >
                    <b-form-input
                      type="number"
                      placeholder=""
                      v-model="item.weight_text"
                      @keyup="calcTotalShipment()"
                    />
                  </b-input-group>
                  <div v-if="error.loadsCargo" class="text-left input-group __input">
                    <small class="text-danger" v-if="error.loadsCargo[i].weight_text  && showError">Required</small>
                  </div>
                </div>
                <div class="row __size">
                  <!-- <p>Volume</p> -->
                  <b-input-group size="md" append="cm">
                    <b-form-input
                      type="number"
                      placeholder="L"
                      v-model="item.size.length"
                      @keyup="calcTotalShipment()"
                    />
                    <b-form-input
                      type="number"
                      placeholder="W"
                      v-model="item.size.width"
                      @keyup="calcTotalShipment()"
                    />
                    <b-form-input
                      type="number"
                      placeholder="H"
                      v-model="item.size.height"
                      @keyup="calcTotalShipment()"
                    />
                  </b-input-group>
                  <div v-if="error.loadsCargo" class="text-left input-group __input">
                    <small class="text-danger" v-if="(error.loadsCargo[i].size.length || error.loadsCargo[i].size.width || error.loadsCargo[i].size.height) && showError">Required</small>
                  </div>
                </div>
                <div
                  v-if="i === 0"
                  class="__btnplus"
                  @click="addContainer()"
                >
                  <img src="@/assets/image/instantprice/Group 2626.png" alt="" />
                </div>
                <div
                  v-else
                  class="__btnremove"
                  @click="removeContainer(i)"
                >
                  <img src="@/assets/image/instantprice/buttonX.png" alt="" />
                </div>
              </div>  <!-- end __inputfield -->
            </div>
          </div>

          <div v-else>
             <div class="d-flex justify-content-center __inputfield" style="margin-bottom: 70px">
                <div class="row __customdropdown">
                  <p>Qty</p>
                </div>
                <div class="row row __weight">
                  <p>Weight</p>
                </div>
                <div class="row row __size">
                  <p>Volume</p>
                </div>
            </div>
            <div
              v-for="(item, i) in form.loadsAIRCourier"
              v-bind:key="i">
              <div class="d-flex justify-content-center align-items-center __inputfield" style="margin-top: -53px; margin-bottom: 70px;">
                <div class="row __customdropdown">
                  <!-- <p>Qty</p> -->
                  <b-input-group>
                    <b-form-input
                      placeholder=""
                      type="number"
                      v-model="item.qty"
                      @keyup="calcTotalShipment()"
                    />
                    <b-dropdown right text="Palletes" variant="" slot="append"
                      :disabled="i > 0">
                      <template slot="button-content">
                        {{ item.type }}
                      </template>
                      <b-dropdown-item
                        @click="setType('Boxes')">
                        <span>Boxes</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="setType('Crates')">
                        <span>Crates</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="setType('Palletes')">
                        <span>Palletes</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group>
                  <div v-if="error.loadsCourier" class="text-left input-group __input">
                    <small class="text-danger" v-if="error.loadsCourier[i].qty && showError">Required</small>
                  </div>
                </div>
                <div class="row __weight">
                  <!-- <p>Weight</p> -->
                  <b-input-group
                    size="md"
                    append="kg"
                  >
                    <b-form-input
                      type="number"
                      placeholder=""
                      v-model="item.weight_text"
                      @keyup="calcTotalShipment()"
                    />
                  </b-input-group>
                  <div v-if="error.loadsCourier" class="text-left input-group __input">
                    <small class="text-danger" v-if="error.loadsCourier[i].weight_text && showError">Required</small>
                  </div>
                </div>
                <div class="row __size">
                  <!-- <p>Volume</p> -->
                  <b-input-group size="md" append="cm">
                    <b-form-input
                      v-model="item.size.length"
                      type="number"
                      placeholder="L"
                      @keyup="calcTotalShipment()"
                    />
                    <b-form-input
                      v-model="item.size.width"
                      @keyup="calcTotalShipment()"
                      type="number"
                      placeholder="W"
                    />
                    <b-form-input
                      v-model="item.size.height"
                      @keyup="calcTotalShipment()"
                      type="number"
                      placeholder="H"
                    />
                  </b-input-group>
                  <div v-if="error.loadsCourier" class="text-left input-group __input">
                    <small class="text-danger" v-if="(error.loadsCourier[i].size.length || error.loadsCourier[i].size.width || error.loadsCourier[i].size.height) && showError">Required</small>
                  </div>
                </div>
                <div
                  v-if="i === 0"
                  class="__btnplus"
                  @click="addContainer()"
                >
                  <img src="@/assets/image/instantprice/Group 2626.png" alt="" />
                </div>
                <div
                  v-else
                  class="__btnremove"
                  @click="removeContainer(i)"
                >
                  <img src="@/assets/image/instantprice/buttonX.png" alt="" />
                </div>
              </div>  <!-- end __inputfield -->
            </div>
          </div>

          <div class="_total__box_" style="max-width:550px">
            <div class="row">
              <p class="col-md-4">Total Shipment: </p>
              <p class="col-md-8">  {{ totalUnit }} {{ units }} / {{ totalVolumetric }} Volumetric / {{totalWeight}} Kg</p>
            </div>
          </div>
      </div>
    </div> <!-- end __centerblock -->
  </div>
</template>

<script>
export default {
  name: 'shipment_air',
  props: {
    showError: Boolean,
    checkErrorStat: String
  },
  data () {
    return {
      header: {
        id: 1,
        subtitle: 'Air cargo'
      },
      form: {
        service_head: 'AIR',
        shipmentType: 'AIRCARGO',
        shipment_type: 'AIRCARGO',
        typeObj: 'sub',
        loadsAIRCourier: [{
          size: {
            length: '',
            width: '',
            height: '',
            unit: 'cbm'
          },
          qty: '',
          type: 'box',
          weight: '',
          volume: this.totalVolumetric,
          weightUnit: 'kg',
          vm: 0,
          weight_text: ''
        }],
        loadsAIRCargo: [{
          size: {
            length: '',
            width: '',
            height: '',
            unit: 'cbm'
          },
          qty: '',
          type: 'box',
          weight: '',
          volume: this.totalVolumetric,
          weightUnit: 'kg',
          vm: 0,
          weight_text: ''
        }],
        lengthdimension: 0,
        widthdimension: 0,
        heightdimension: 0,
        totalVolumetric: 0,
        totalWeight: 0,
        totalUnit: 0
      },
      type: 'cargo',
      volumetric: 0,
      totalUnit: 0,
      totalVolumetric: 0,
      totalWeight: 0,
      isCargo: true,
      isCourier: false,
      loadsDisplay: [],
      inputLoads: {
        size: {
          length: '',
          width: '',
          height: '',
          unit: 'cbm'
        },
        qty: '',
        type: 'box',
        weight: '',
        weightUnit: 'kg'
      },
      error: {
        loadsCargo: [{
          size: {
            length: null,
            width: null,
            height: null,
            unit: 'cbm'
          },
          qty: null,
          weight: null
        }]
      },
      errorData: {},
      units: 'Box'
    }
  },
  methods: {
    chooseAir (type) {
      this.isCargo = type === 'cargo'
      this.isCourier = type === 'courier'
      this.type = type
      this.form.shipment_type = ('Air' + type).toUpperCase()
      this.form.shipmentType = ('Air' + type).toUpperCase()
      this.pushData()

      this.$emit('IntantPriceShipmentType', 'Air ' + type)
      this.$emit('IntantPriceData', { shipmentLoad: 'air' + type })
    },
    addContainer () {
      let arr = this.type === 'cargo' ? this.form.loadsAIRCargo : this.form.loadsAIRCourier
      let i = arr.length + 1

      this.inputLoads.id = i

      let arrCargo = this.form.loadsAIRCargo
      let arrCourier = this.form.loadsAIRCourier
      if (this.type === 'cargo') {
        arrCargo.push({
          size: {
            length: '',
            width: '',
            height: '',
            unit: 'cbm'
          },
          qty: '',
          type: 'box',
          weight: '',
          volume: '',
          weightUnit: 'kg'
        })
      } else {
        arrCourier.push({
          size: {
            length: '',
            width: '',
            height: '',
            unit: 'cbm'
          },
          qty: '',
          type: 'box',
          weight: '',
          volume: '',
          weightUnit: 'kg'
        })
      }
      this.calcTotalShipment()
      this.pushData()
    },
    removeContainer (index) {
      let arrLoads = this.type === 'cargo' ? this.form.loadsAIRCargo : this.form.loadsAIRCourier

      this.$delete(arrLoads, index)
      this.calcTotalShipment()
      this.pushData()
    },
    pushData () {
      this.form.loadsAIRCourier[0].weight = this.form.loadsAIRCourier[0].weight * this.form.loadsAIRCourier[0].qty
      this.form.loadsAIRCargo[0].weight = this.form.loadsAIRCargo[0].weight * this.form.loadsAIRCargo[0].qty
      this.$emit('IntantPriceData', this.form)
    },
    calcVM (size) {
      let vm = 1
      let volume = parseInt(size.length) * parseInt(size.width) * parseInt(size.height)

      if (this.type === 'cargo') {
        vm = Math.ceil((volume * this.totalUnit) / 6000)
      } else {
        vm = this.roundToHalf((volume * this.totalUnit) / 5000)
      }

      return !isNaN(vm) ? vm : 0
    },
    roundToHalf (value) {
      const converted = parseFloat(value) // Make sure we have a number
      let decimal = (converted - parseInt(converted, 10))
      decimal = Math.round(decimal * 10)
      if (decimal === 5) { return (parseInt(converted, 10) + 0.5) }
      if ((decimal < 1) || (decimal > 5)) {
        return Math.round(converted)
      }
      return (parseInt(converted, 10) + 0.5)
    },
    calcTotalShipment () {
      let arr = this.type === 'cargo' ? this.form.loadsAIRCargo : this.form.loadsAIRCourier
      this.inputLoads.vm = arr.reduce((total, obj) => parseFloat(obj.vm) + parseFloat(total), 0)
      const totalWeightTemp = arr.reduce((total, obj) => (parseFloat(obj.weight_text ? obj.weight_text : 0) * parseInt(obj.qty ? obj.qty : 0)) + parseFloat(total), 0)
      const totalWeight = this.type === 'courier' ? this.roundToHalf(totalWeightTemp) : Math.ceil(totalWeightTemp)
      this.totalWeight = totalWeight
      this.weight = totalWeight
      this.totalUnit = (arr.reduce((total, obj) => parseInt(obj.qty ? obj.qty : 0) + parseInt(total), 0))
      this.totalVolumetric = arr.reduce((total, obj) => parseFloat(this.calcVM(obj.size ? obj.size : 0)) + parseFloat(total), 0)
      this.form.lengthdimension = this.type === 'cargo' ? this.form.loadsAIRCargo[0].size.length : this.form.loadsAIRCourier[0].size.length
      this.form.widthdimension = this.type === 'cargo' ? this.form.loadsAIRCargo[0].size.width : this.form.loadsAIRCourier[0].size.width
      this.form.heightdimension = this.type === 'cargo' ? this.form.loadsAIRCargo[0].size.height : this.form.loadsAIRCourier[0].size.height
      this.form.totalUnit = this.totalUnit
      this.form.totalWeight = this.totalWeight
      this.form.totalVolumetric = this.totalVolumetric

      this.$emit('IntantPriceData', this.form)
      if (this.type === 'cargo') {
        this.checkErrorCargo()
      } else {
        this.checkErrorCourier()
      }
    },
    setType (type) {
      let arr = this.type === 'cargo' ? this.form.loadsAIRCargo : this.form.loadsAIRCourier
      arr.reduce((total, obj) => { obj.type = type }, {})
      this.inputLoads.type = type
      this.units = type
    },
    checkErrorCargo () {
      let error = this.error
      const loadsArrayCargoErrors = []
      this.form.loadsAIRCargo.forEach((load, loadIndex) => {
        const loadsErrors = { qty: null, weight_text: null, size: { length: null, width: null, height: null, unit: null } }

        this.form.loadsAIRCargo[loadIndex].weight = load.weight_text
        if (!load.qty || load.qty < 1) {
          loadsErrors.qty = true
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        }

        if (!load.weight_text || load.weight_text < 1) {
          loadsErrors.weight_text = true
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        }

        if (load.size.length || load.size.length > 1) {
          loadsErrors.size.length = null
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.length = true
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        }

        if (!load.size.width || load.size.width < 1) {
          loadsErrors.size.width = true
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.width = null
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        }

        if (!load.size.height || load.size.height < 1) {
          loadsErrors.size.height = true
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.height = null
          loadsArrayCargoErrors[loadIndex] = loadsErrors
        }

        if (!loadsErrors.qty && !loadsErrors.weight_text && !loadsErrors.size.length && !loadsErrors.size.width && !loadsErrors.size.height) {
          this.errorData.errorsCargo = false
        } else {
          this.errorData.errorsCargo = true
        }
        return loadsErrors
      })
      if (loadsArrayCargoErrors.length) {
        error.loadsCargo = loadsArrayCargoErrors
      }

      this.$emit('errorInput', this.errorData)
    },
    checkErrorCourier () {
      let error = this.error
      const loadsArrayCourierErrors = []
      this.form.loadsAIRCourier.forEach((load, loadIndex) => {
        const loadsErrors = { qty: null, weight_text: null, size: { length: null, width: null, height: null, unit: null } }

        this.form.loadsAIRCourier[loadIndex].weight = load.weight_text
        if (!load.qty || load.qty < 1) {
          loadsErrors.qty = true
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        }

        if (!load.weight_text || load.weight_text < 1) {
          loadsErrors.weight_text = true
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        }

        if (load.size.length || load.size.length > 1) {
          loadsErrors.size.length = null
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.length = true
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        }

        if (!load.size.width || load.size.width < 1) {
          loadsErrors.size.width = true
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.width = null
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        }

        if (!load.size.height || load.size.height < 1) {
          loadsErrors.size.height = true
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.height = null
          loadsArrayCourierErrors[loadIndex] = loadsErrors
        }

        if (!loadsErrors.qty && !loadsErrors.weight && !loadsErrors.size.length && !loadsErrors.size.width && !loadsErrors.size.height) {
          this.errorData.errorsCourier = false
        } else {
          this.errorData.errorsCourier = true
        }
        return loadsErrors
      })
      if (loadsArrayCourierErrors.length) {
        error.loadsCourier = loadsArrayCourierErrors
      }

      this.$emit('errorInput', this.errorData)
    }
  },
  mounted () {
    this.isCargo = true
    this.$emit('IntantPriceShipmentType', 'Air Cargo')
    this.pushData()
    this.$emit('IntantPriceData', { shipmentLoad: 'air' + this.type })
    this.checkErrorCargo()
    this.checkErrorCourier()
  },
  watch: {
    type (newData, oldData) {
      if (newData !== oldData) {
        this.calcTotalShipment()
      }
    },
    isCargo (data) {
      if (data) {
        this.$emit('IntantPriceShipmentType', 'Air Cargo')
        this.$emit('IntantPriceData', { shipmentLoad: 'aircargo' })
      }
    },
    checkErrorStat (newData) {
      if (this.type === 'cargo') {
        this.checkErrorCargo()
      } else {
        this.checkErrorCourier()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/ShipmentAir.vue